// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CareerPathsWrapper_wrapper__g4WTr","card-wrapper":"CareerPathsWrapper_card-wrapper__IpbbE"};